export default __webpack_public_path__ + "static/media/49.a34abb18.png";